import { EmptyState } from '@/components/ri/EmptyState';
import { I } from '@/components/ri/icons';

export default function ApprovalAccessDenied() {
  return (
    <div style={{ display: 'grid', minHeight: 'calc(100vh - 180px)', placeItems: 'center' }}>
      <EmptyState
        icon={I.shield}
        title="Approvals require an Admin or Manager role"
        body="Your current role cannot review or decide approval requests."
      />
    </div>
  );
}
